webpackJsonp([5],{

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("zNXH");


/***/ }),

/***/ "zNXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./assets/js/timetable/Timetable.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Timetable = ({
  name: 'timetable',
  computed: extends_default()({}, Object(vuex_esm["f" /* mapState */])(['ready', 'days', 'filter']), Object(vuex_esm["e" /* mapGetters */])(['filterActive'])),
  components: {
    FilterBar: function FilterBar() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "SOWF"));
    },
    Day: function Day() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Sz75"));
    }
  },
  methods: Object(vuex_esm["d" /* mapActions */])(['loadFromRemote']),
  mounted: function mounted() {
    this.loadFromRemote();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019abf84","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/timetable/Timetable.vue
var Timetable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"schedule"}},[_c('div',{staticClass:"row"},[_c('filter-bar'),_vm._v(" "),_vm._l((_vm.days),function(day){return (_vm.ready)?_c('day',{key:day.day,attrs:{"ready":_vm.ready,"day":day,"filter":_vm.filter,"filterActive":_vm.filterActive}}):_vm._e()}),_vm._v(" "),(!_vm.ready)?_c('day',{attrs:{"ready":_vm.ready,"filter":_vm.filter,"filterActive":_vm.filterActive}}):_vm._e()],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./assets/js/timetable/Timetable.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  Timetable,
  Timetable_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var timetable_Timetable = (Component.exports);

// CONCATENATED MODULE: ./assets/js/timetable/table.js



function createTimetable(store) {
  return new vue_runtime_esm["a" /* default */]({
    store: store,
    render: function render(h) {
      return h(timetable_Timetable);
    }
  });
}
// EXTERNAL MODULE: external "jQuery"
var external__jQuery_ = __webpack_require__("0iPh");
var external__jQuery__default = /*#__PURE__*/__webpack_require__.n(external__jQuery_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./assets/js/timetable/Modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* globals window, URL, URLSearchParams, FB, ClipboardJS, Materialize */

var _createNamespacedHelp = Object(vuex_esm["b" /* createNamespacedHelpers */])('modal'),
    mapState = _createNamespacedHelp.mapState,
    mapActions = _createNamespacedHelp.mapActions;

var frameOptions = 'toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=200,width=800,height=400';

/* harmony default export */ var Modal = ({
  name: 'modal',
  computed: extends_default()({
    link: function link() {
      if (!this.event.internal) {
        return '';
      }

      var url = new URL(this.event.internal);
      return url.pathname.replace('/event/', '/2018/topic/');
    },
    shareLink: function shareLink() {
      return window.location.protocol + '//' + window.location.host + this.link + '?utm_medium=share&utm_campaign=website_share';
    }
  }, mapState(['open', 'event'])),
  methods: extends_default()({
    openFacebook: function openFacebook() {
      FB.ui({
        app_id: '1826257884309248',
        method: 'share',
        mobile_iframe: true,
        href: this.shareLink + '&utm_source=facebook'
      });
    },
    openTwitter: function openTwitter() {
      var params = new URLSearchParams();
      params.append('url', this.shareLink + '&utm_source=twitter');
      params.append('via', 'hkoscon');
      params.append('hashtags', 'hkoscon,hkoscon2018');
      var speaker = this.event.speakers.map(function (s) {
        return s.name;
      }).join(' and ');
      params.append('text', speaker + ' in going to deliver "' + this.event.display + '" in HKOSCon 2018');
      window.open('https://twitter.com/share?' + params.toString(), '_blank', frameOptions);
    }
  }, mapActions(['closeModal'])),
  mounted: function mounted() {
    var _this = this;

    // eslint-disable-next-line no-new
    var clipboard = new ClipboardJS(this.$refs.share);
    clipboard.on('success', function (e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      Materialize.toast('Link is Copied', 3000, 'rounded');
      e.clearSelection();
    });
    window.addEventListener('keyup', function (e) {
      if (_this.open && e.code === 'Escape') {
        _this.closeModal();
      }
    });
  },
  updated: function updated() {
    this.$nextTick(function () {
      external__jQuery__default()('ul.tabs').tabs();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e46ebb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/js/timetable/Modal.vue
var Modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ show: _vm.open },attrs:{"id":"modal"}},[_c('div',{staticClass:"modal modal-fixed-footer modal-event-details"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"metadata"},[_c('div',{staticClass:"main-info"},[_c('div',{staticClass:"info"},[((_vm.event.video_recordings && _vm.event.video_recordings.length) > 0 || (_vm.event.slides && _vm.event.slides.length > 0))?_c('div',{staticClass:"container post-event"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('ul',{staticClass:"tabs"},[_vm._l((_vm.event.video_recordings),function(video,index){return (_vm.event.video_recordings)?_c('li',{key:index,staticClass:"tab col s3"},[_c('a',{attrs:{"href":("#video-" + (index+1))}},[_vm._v("Video "+_vm._s(index + 1))])]):_vm._e()}),_vm._v(" "),(_vm.event.slides && _vm.event.slides.length > 0)?_c('li',{staticClass:"tab col s3"},[_c('a',{attrs:{"href":"#slides"}},[_vm._v("Slides")])]):_vm._e()],2),_vm._v(" "),_vm._l((_vm.event.video_recordings),function(video,index){return _c('div',{key:index,staticClass:"col s12",attrs:{"id":("video-" + (index+1))},domProps:{"innerHTML":_vm._s(video.html)}})}),_vm._v(" "),(_vm.event.slides && _vm.event.slides.length > 0)?_c('div',{attrs:{"id":"slides"}},[_c('ul',_vm._l((_vm.event.slides),function(slides,index){return _c('li',{key:index},[_c('a',{attrs:{"href":slides.url}},[_vm._v(_vm._s(slides.title))])])}))]):_vm._e()],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.event.display))]),_vm._v(" "),(_vm.event.topic && _vm.event.speakers && _vm.event.speakers.length > 0)?_c('div',{staticClass:"speaker-thumbnails"},[_c('ul',_vm._l((_vm.event.speakers),function(speaker,index){return _c('li',{key:index,staticClass:"speaker-thumbnail"},[(!speaker.thumbnail)?_c('i',{staticClass:"material-icons"},[_vm._v("account_circle")]):_vm._e(),_vm._v(" "),(speaker.thumbnail)?_c('img',{attrs:{"src":speaker.thumbnail,"alt":speaker.name,"title":speaker.name}}):_vm._e()])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"summary"},[_c('div',{staticClass:"datetime"},[_c('i',{staticClass:"material-icons"},[_vm._v("event")]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v("Day "+_vm._s(_vm.event.day))]),_vm._v(",\n                                "),_c('span',{staticClass:"time time-start"},[_vm._v(_vm._s(_vm.event.startTime))]),_vm._v(" -\n                                "),_c('span',{staticClass:"time time-end"},[_vm._v(_vm._s(_vm.event.endTime))])]),_vm._v(" "),(_vm.event.venue && _vm.event.venue.name)?_c('div',{staticClass:"venue"},[_c('i',{staticClass:"material-icons"},[_vm._v("explore")]),_vm._v("\n                                "+_vm._s(_vm.event.venue.name)+"\n                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"misc"},[(_vm.event.language)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("message")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.event.language))])]):_vm._e(),_vm._v(" "),(_vm.event.topic && _vm.event.level)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("network_check")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.event.level))])]):_vm._e()])]),_vm._v(" "),(_vm.event.description)?_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.event.description)}}):_vm._e(),_vm._v(" "),(_vm.event.topic && _vm.event.speakers && _vm.event.speakers.length > 0)?_c('div',{staticClass:"card person-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"speakers"},_vm._l((_vm.event.speakers),function(speaker,index){return _c('div',{key:index,staticClass:"speaker"},[_c('div',{staticClass:"thumbnail"},[(!speaker.thumbnail)?_c('i',{staticClass:"material-icons"},[_vm._v("account_circle")]):_vm._e(),_vm._v(" "),(speaker.thumbnail)?_c('img',{attrs:{"src":speaker.thumbnail,"alt":speaker.name,"title":speaker.name}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"name"},[_c('span',[_vm._v(_vm._s(speaker.name))])]),_vm._v(" "),(speaker.description && speaker.description != '')?_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(speaker.description)}}):_vm._e(),_vm._v(" "),(speaker.community || speaker.country)?_c('div',{staticClass:"affiliations"},[_c('ul',[(speaker.community)?_c('li',[_vm._v(_vm._s(speaker.community))]):_vm._e(),_vm._v(" "),(speaker.country)?_c('li',[_vm._v(_vm._s(speaker.country))]):_vm._e()])]):_vm._e()])])}))])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"share"},[_c('button',{staticClass:"btn-floating btn-large waves-effect waves-light facebook",on:{"click":_vm.openFacebook}},[_c('i',{staticClass:"fa fa-facebook",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn-floating btn-large waves-effect waves-light twitter",on:{"click":_vm.openTwitter}},[_c('i',{staticClass:"fa fa-twitter",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{ref:"share",staticClass:"btn-floating btn-large waves-effect waves-light primary",attrs:{"data-clipboard-text":((this.shareLink) + "&utm_source=clipboard")}},[_c('i',{staticClass:"material-icons"},[_vm._v("share")])])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('a',{staticClass:"modal-action waves-effect waves-light btn",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener"}},[_vm._v("Permlink")]),_vm._v(" "),_c('button',{staticClass:"modal-action waves-effect waves-light btn",on:{"click":_vm.closeModal}},[_vm._v("Close")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}})])}
var Modal_staticRenderFns = []

// CONCATENATED MODULE: ./assets/js/timetable/Modal.vue
/* script */


/* template */

/* template functional */
var Modal___vue_template_functional__ = false
/* styles */
var Modal___vue_styles__ = null
/* scopeId */
var Modal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Modal___vue_module_identifier__ = null

var Modal_Component = Object(component_normalizer["a" /* default */])(
  Modal,
  Modal_render,
  Modal_staticRenderFns,
  Modal___vue_template_functional__,
  Modal___vue_styles__,
  Modal___vue_scopeId__,
  Modal___vue_module_identifier__
)

/* harmony default export */ var timetable_Modal = (Modal_Component.exports);

// CONCATENATED MODULE: ./assets/js/timetable/modal.js



function createModal(store) {
  return new vue_runtime_esm["a" /* default */]({
    store: store,
    render: function render(h) {
      return h(timetable_Modal);
    }
  });
}
// CONCATENATED MODULE: ./assets/js/timetable/store/state.js
/* harmony default export */ var state = ({
  days: null,
  ready: false,
  modal: false
});
// CONCATENATED MODULE: ./assets/js/timetable/store/mutations.js
/* harmony default export */ var mutations = ({
  setReady: function setReady(state, done) {
    state.ready = done;
  },
  importDays: function importDays(state, days) {
    state.days = days;
  }
});
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./assets/js/timetable/store/actions.js


/* harmony default export */ var actions = ({
  loadFromRemote: function loadFromRemote(_ref) {
    var commit = _ref.commit;

    axios_default.a.get("/2018/data/timetable.json").then(function (_ref2) {
      var data = _ref2.data;

      commit('importDays', data.days);
      commit('setReady', true);
    });
  }
});
// CONCATENATED MODULE: ./assets/js/timetable/store/getters.js
/* harmony default export */ var getters = ({
  filterActive: function filterActive(_ref) {
    var filter = _ref.filter;

    return filter.level.length > 0;
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./assets/js/timetable/store/modules/filter.js

var SET_LEVEL = 'SET_LEVEL';

/* harmony default export */ var filter = ({
  namespaced: true,
  state: {
    level: []
  },
  mutations: defineProperty_default()({}, SET_LEVEL, function (state, level) {
    state.level = level;
  }),
  getters: {
    activeLevels: function activeLevels(_ref) {
      var level = _ref.level;

      return level;
    }
  },
  actions: {
    addLevel: function addLevel(_ref2, level) {
      var commit = _ref2.commit,
          state = _ref2.state;

      commit(SET_LEVEL, [level].concat(state.level || []));
    },
    removeLevel: function removeLevel(_ref3, level) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit(SET_LEVEL, (state.level || []).filter(function (l) {
        return l !== level;
      }));
    },
    clearLevel: function clearLevel(_ref4) {
      var commit = _ref4.commit;

      commit(SET_LEVEL, []);
    },
    toggleLevel: function toggleLevel(_ref5, level) {
      var dispatch = _ref5.dispatch,
          state = _ref5.state;

      if (state.level.indexOf(level) !== -1) {
        dispatch('removeLevel', level);
      } else {
        dispatch('addLevel', level);
      }
    }
  }
});
// CONCATENATED MODULE: ./assets/js/timetable/store/modules/modal.js


var _mutations;

var SET_EVENT = 'SET_EVENT';
var TOGGLE_MODAL = 'TOGGLE_MODAL';

var modal_event = {
  day: 0,
  startTime: '00:00',
  endTime: '00:00',
  display: '',
  language: '',
  level: '',
  speaker: {
    name: '',
    country: null,
    community: null
  },
  topic: false,
  venue: {
    name: ''
  }
};

/* harmony default export */ var modal = ({
  namespaced: true,
  state: {
    event: modal_event,
    open: false
  },
  mutations: (_mutations = {}, defineProperty_default()(_mutations, SET_EVENT, function (state, e) {
    state.event = e;
  }), defineProperty_default()(_mutations, TOGGLE_MODAL, function (state) {
    state.open = !state.open;
  }), _mutations),
  actions: {
    openModal: function openModal(_ref, e) {
      var commit = _ref.commit;

      commit(SET_EVENT, e);
      commit(TOGGLE_MODAL);
    },
    closeModal: function closeModal(_ref2) {
      var commit = _ref2.commit;

      commit(SET_EVENT, modal_event);
      commit(TOGGLE_MODAL);
    }
  }
});
// CONCATENATED MODULE: ./assets/js/timetable/store/index.js










vue_runtime_esm["a" /* default */].use(vuex_esm["c" /* default */]);

function createStore() {
  return new vuex_esm["a" /* Store */]({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
    modules: {
      filter: filter,
      modal: modal
    }
  });
}
// CONCATENATED MODULE: ./assets/js/timetable/index.js




var timetable_store = createStore();
var timetable = createTimetable(timetable_store);
timetable.$mount('#schedule');

var timetable_modal = createModal(timetable_store);
timetable_modal.$mount('#modal');
/* globals window, FB */
window.fbAsyncInit = function () {
  FB.init({
    appId: "1826257884309248",
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v3.0'
  });
};

/***/ })

},[1]);


// WEBPACK FOOTER //
// timetable.59818752738b42ad001a.js